/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withTranslation} from 'react-i18next';
import {translate} from '@ion/core/src/locale/locale';
import ErrorIcon from '@ion/dls/src/icons/ErrorIcon';
import UserNotificationDialog from '@ion/dls/src/notifications/UserNotificationDialog';

/**
 * Defines the ReportProcessingPrompt Prop types definitions.
 */
interface ReportProcessingPromptProps {
  onClose: () => void;
}

/**
 * @internal
 *
 * Defines the `ReportsProcessingPrompt` component which provides the notification
 * for informing the user that reports are currently being processed for the given
 * account.
 */
const ReportsProcessingPrompt = ({onClose}: ReportProcessingPromptProps) => {
  return (
    <UserNotificationDialog icon={<ErrorIcon />}
      title={translate('reports:processing.title')}
      message={translate('reports:processing.message')}
      actionLabel={translate('reports:processing.action')}
      iconMargin={'-2px 12px 0 0'}
      onAction={onClose}
      maxWidth={560}
      allowWhitespace
      curvedCorners
      capitalize
      show />
  );
};

export default withTranslation(['reports'])(
  ReportsProcessingPrompt
);
